const nsw = {
  title: 'New South Wales',
  links: [
    {
      anchorText: 'Coffs Harbour',
      searchAreaId: '29410',
      path: 'coffs-harbour-nsw',
    },
    {
      anchorText: 'Shellharbour',
      searchAreaId: '29419',
      path: 'shellharbour-nsw',
    },
    {
      anchorText: 'Albion Park',
      searchAreaId: '16925',
      path: 'albion-park-nsw',
    },
    {
      anchorText: 'Central Coast',
      searchAreaId: '28775',
      path: 'central-coast-nsw',
    },
    {
      anchorText: 'Newcastle',
      searchAreaId: '29195',
      path: 'newcastle-nsw',
    },
    {
      anchorText: 'Port Macquarie',
      searchAreaId: '29411',
      path: 'port-macquarie-nsw',
    },
    {
      anchorText: 'Tamworth',
      searchAreaId: '16480',
      path: 'tamworth-nsw',
    },
    {
      anchorText: 'Lismore',
      searchAreaId: '11297',
      path: 'lismore-nsw-2480',
    },
    {
      anchorText: 'Casino',
      searchAreaId: '11209',
      path: 'casino-nsw',
    },
    {
      anchorText: 'Taree',
      searchAreaId: '29413',
      path: 'taree-nsw',
    },
    {
      anchorText: 'Forster',
      searchAreaId: '12141',
      path: 'forster-nsw',
    },
    {
      anchorText: 'Wollongong',
      searchAreaId: '30264',
      path: 'wollongong-nsw',
    },
    {
      anchorText: 'Dubbo',
      searchAreaId: '29415',
      path: 'dubbo-nsw',
    },
    {
      anchorText: 'Wagga Wagga',
      searchAreaId: '29506',
      path: 'wagga-wagga-nsw-2650',
    },
    {
      anchorText: 'Kempsey',
      searchAreaId: '11501',
      path: 'kempsey-nsw-2440',
    },
    {
      anchorText: 'Maitland',
      searchAreaId: '29416',
      path: 'maitland-nsw',
    },
    {
      anchorText: 'Tweed Heads',
      searchAreaId: '12461',
      path: 'tweed-heads-nsw',
    },
    {
      anchorText: 'Ballina',
      searchAreaId: '11181',
      path: 'ballina-nsw-2478',
    },
    {
      anchorText: 'Armidale',
      searchAreaId: '16538',
      path: 'armidale-nsw',
    },
    {
      anchorText: 'Bathurst',
      searchAreaId: '29510',
      path: 'bathurst-nsw',
    },
    {
      anchorText: 'Grafton',
      searchAreaId: '10422',
      path: 'grafton-nsw',
    },
    {
      anchorText: 'Albury',
      searchAreaId: '29422',
      path: 'albury-nsw',
    },
    {
      anchorText: 'Nowra',
      searchAreaId: '29420',
      path: 'nowra-nsw',
    },
    {
      anchorText: 'Singleton',
      searchAreaId: '15147',
      path: 'singleton-nsw-2330',
    },
    {
      anchorText: 'Lake Macquarie',
      searchAreaId: '14152',
      path: 'lake-macquarie-nsw',
    },
    {
      anchorText: 'Orange',
      searchAreaId: '29511',
      path: 'orange-nsw',
    },
    {
      anchorText: 'Nelson Bay',
      searchAreaId: '11638',
      path: 'nelson-bay-nsw',
    },
    {
      anchorText: 'Gloucester',
      searchAreaId: '12148',
      path: 'gloucester-nsw-2422',
    },
    {
      anchorText: 'Byron Bay',
      searchAreaId: '11206',
      path: 'byron-bay-nsw',
    },
    {
      anchorText: 'Southern Highlands',
      searchAreaId: '28776',
      path: 'southern-highlands-nsw',
    },
    {
      anchorText: 'Murwillumbah',
      searchAreaId: '12433',
      path: 'murwillumbah-nsw',
    },
    {
      anchorText: 'Gosford',
      searchAreaId: '16158',
      path: 'gosford-nsw-2250',
    },
    {
      anchorText: 'Port Stephens',
      searchAreaId: '29426',
      path: 'port-stephens-nsw',
    },
    {
      anchorText: 'Wauchope',
      searchAreaId: '11586',
      path: 'wauchope-nsw',
    },
    {
      anchorText: 'Gunnedah',
      searchAreaId: '16721',
      path: 'gunnedah-nsw-2380',
    },
    {
      anchorText: 'Bowral',
      searchAreaId: '17357',
      path: 'bowral-nsw',
    },
    {
      anchorText: 'East Maitland',
      searchAreaId: '14022',
      path: 'east-maitland-nsw',
    },
    {
      anchorText: 'Toronto',
      searchAreaId: '14362',
      path: 'toronto-nsw',
    },
    {
      anchorText: 'Wingham',
      searchAreaId: '12253',
      path: 'wingham-nsw',
    },
    {
      anchorText: 'Wellington',
      searchAreaId: '18725',
      path: 'wellington-nsw-2820',
    },
    {
      anchorText: 'Wyong',
      searchAreaId: '16256',
      path: 'wyong-nsw-2259',
    },
    {
      anchorText: 'Macksville',
      searchAreaId: '10468',
      path: 'macksville-nsw',
    },
    {
      anchorText: 'Cessnock',
      searchAreaId: '29417',
      path: 'cessnock-nsw',
    },
    {
      anchorText: 'Alstonville',
      searchAreaId: '11178',
      path: 'alstonville-nsw',
    },
    {
      anchorText: 'Umina Beach',
      searchAreaId: '16218',
      path: 'umina-beach-nsw',
    },
    {
      anchorText: 'Inverell',
      searchAreaId: '16613',
      path: 'inverell-nsw-2360',
    },
    {
      anchorText: 'Ulladulla',
      searchAreaId: '17068',
      path: 'ulladulla-nsw',
    },
    {
      anchorText: 'Northern Rivers',
      searchAreaId: '28370',
      path: 'northern-rivers-nsw',
    },
    {
      anchorText: 'Raymond Terrace',
      searchAreaId: '11651',
      path: 'raymond-terrace-nsw',
    },
    {
      anchorText: 'Tea Gardens',
      searchAreaId: '11665',
      path: 'tea-gardens-nsw',
    },
    {
      anchorText: 'Banora Point',
      searchAreaId: '12374',
      path: 'banora-point-nsw',
    },
    {
      anchorText: 'Kiama',
      searchAreaId: '16964',
      path: 'kiama-nsw-2533',
    },
    {
      anchorText: 'Medowie',
      searchAreaId: '11634',
      path: 'medowie-nsw',
    },
    {
      anchorText: 'Kyogle',
      searchAreaId: '11289',
      path: 'kyogle-nsw-2474',
    },
    {
      anchorText: 'Goulburn',
      searchAreaId: '29421',
      path: 'goulburn-nsw',
    },
    {
      anchorText: 'Yamba',
      searchAreaId: '10599',
      path: 'yamba-nsw',
    },
    {
      anchorText: 'Pottsville',
      searchAreaId: '12445',
      path: 'pottsville-nsw',
    },
    {
      anchorText: 'South West Rocks',
      searchAreaId: '11562',
      path: 'south-west-rocks-nsw',
    },
    {
      anchorText: 'Cardiff',
      searchAreaId: '13953',
      path: 'cardiff-nsw',
    },
    {
      anchorText: 'Muswellbrook',
      searchAreaId: '16395',
      path: 'muswellbrook-nsw-2333',
    },
    {
      anchorText: 'Belmont',
      searchAreaId: '13902',
      path: 'belmont-nsw',
    },
    {
      anchorText: 'Dapto',
      searchAreaId: '16950',
      path: 'dapto-nsw',
    },
    {
      anchorText: 'Nambucca Heads',
      searchAreaId: '10490',
      path: 'nambucca-heads-nsw',
    },
    {
      anchorText: 'Kurri Kurri',
      searchAreaId: '14146',
      path: 'kurri-kurri-nsw',
    },
    {
      anchorText: 'Lithgow',
      searchAreaId: '18503',
      path: 'lithgow-nsw-2790',
    },
    {
      anchorText: 'Wallsend',
      searchAreaId: '14387',
      path: 'wallsend-nsw',
    },
    {
      anchorText: 'Coonabarabran',
      searchAreaId: '16582',
      path: 'coonabarabran-nsw',
    },
    {
      anchorText: 'Moss Vale',
      searchAreaId: '17382',
      path: 'moss-vale-nsw',
    },
    {
      anchorText: 'Lennox Head',
      searchAreaId: '11293',
      path: 'lennox-head-nsw',
    },
    {
      anchorText: 'Batemans Bay',
      searchAreaId: '29508',
      path: 'batemans-bay-nsw',
    },
    {
      anchorText: 'Woy Woy',
      searchAreaId: '16206',
      path: 'woy-woy-nsw',
    },
    {
      anchorText: 'Laurieton',
      searchAreaId: '11516',
      path: 'laurieton-nsw',
    },
    {
      anchorText: 'Kingscliff',
      searchAreaId: '12425',
      path: 'kingscliff-nsw',
    },
    {
      anchorText: 'Mittagong',
      searchAreaId: '17350',
      path: 'mittagong-nsw',
    },
    {
      anchorText: 'Woolgoolga',
      searchAreaId: '10595',
      path: 'woolgoolga-nsw',
    },
    {
      anchorText: 'Swansea',
      searchAreaId: '14336',
      path: 'swansea-nsw',
    },
    {
      anchorText: 'Charlestown',
      searchAreaId: '13973',
      path: 'charlestown-nsw',
    },
    {
      anchorText: 'Tuncurry',
      searchAreaId: '12234',
      path: 'tuncurry-nsw',
    },
    {
      anchorText: 'Mullumbimby',
      searchAreaId: '11322',
      path: 'mullumbimby-nsw',
    },
    {
      anchorText: 'Bellingen',
      searchAreaId: '10332',
      path: 'bellingen-nsw-2454',
    },
    {
      anchorText: 'Shoalhaven Heads',
      searchAreaId: '16989',
      path: 'shoalhaven-heads-nsw',
    },
    {
      anchorText: 'Old Bar',
      searchAreaId: '12193',
      path: 'old-bar-nsw',
    },
    {
      anchorText: 'Smiths Lake',
      searchAreaId: '12211',
      path: 'smiths-lake-nsw',
    },
    {
      anchorText: 'Wangi Wangi',
      searchAreaId: '14392',
      path: 'wangi-wangi-nsw',
    },
    {
      anchorText: 'Mudgee',
      searchAreaId: '18979',
      path: 'mudgee-nsw',
    },
    {
      anchorText: 'Rutherford',
      searchAreaId: '14306',
      path: 'rutherford-nsw',
    },
    {
      anchorText: 'Maclean',
      searchAreaId: '10469',
      path: 'maclean-nsw',
    },
    {
      anchorText: 'Forster-Tuncurry',
      searchAreaId: '29414',
      path: 'forster-tuncurry-nsw',
    },
    {
      anchorText: 'Thornton',
      searchAreaId: '14354',
      path: 'thornton-nsw',
    },
    {
      anchorText: 'Urunga',
      searchAreaId: '10575',
      path: 'urunga-nsw',
    },
    {
      anchorText: 'Warners Bay',
      searchAreaId: '14397',
      path: 'warners-bay-nsw',
    },
    {
      anchorText: 'Hallidays Point',
      searchAreaId: '12150',
      path: 'hallidays-point-nsw',
    },
    {
      anchorText: 'Goonellabah',
      searchAreaId: '11266',
      path: 'goonellabah-nsw',
    },
    {
      anchorText: 'Narromine',
      searchAreaId: '18729',
      path: 'narromine-nsw-2821',
    },
    {
      anchorText: 'Nimbin',
      searchAreaId: '11334',
      path: 'nimbin-nsw',
    },
    {
      anchorText: 'Cobar',
      searchAreaId: '18856',
      path: 'cobar-nsw-2835',
    },
    {
      anchorText: 'Sussex Inlet',
      searchAreaId: '17120',
      path: 'sussex-inlet-nsw',
    },
    {
      anchorText: 'Thirroul',
      searchAreaId: '16896',
      path: 'thirroul-nsw',
    },
    {
      anchorText: 'Scone',
      searchAreaId: '16423',
      path: 'scone-nsw',
    },
    {
      anchorText: 'Gilgandra',
      searchAreaId: '18766',
      path: 'gilgandra-nsw-2827',
    },
  ],
};

export { nsw };
